import { render, staticRenderFns } from "./AdiSvamdiSchedaDComponent.vue?vue&type=template&id=28e743c6"
import script from "./AdiSvamdiSchedaDComponent.vue?vue&type=script&lang=js"
export * from "./AdiSvamdiSchedaDComponent.vue?vue&type=script&lang=js"
import style0 from "./AdiSvamdiSchedaDComponent.vue?vue&type=style&index=0&id=28e743c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports